export default __webpack_public_path__ + "static/media/1.ec7265b9.jpg";